import { render, staticRenderFns } from "./updpass.vue?vue&type=template&id=1b1a1a3a&"
import script from "./updpass.vue?vue&type=script&lang=js&"
export * from "./updpass.vue?vue&type=script&lang=js&"
import style0 from "./updpass.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports